import navSubmenu from './mando-ui.nav-submenu';

const mediaQuery = window.matchMedia('(min-width: 61.25em)');
const navigation = document.querySelector('.js-nav');
const searchbar = document.querySelector('.js-search-toggle');
const submenus = [];

let activeNav = false;
let mobile = null;

function catchClicks(event) {
  if (activeNav === true && containsCssClass(event.target.classList)) {
    closeMenus(true);
  }
}

function closeMenus(reset, id = '') {
  submenus.forEach((submenu) => {
    if (submenu.expanded === true && submenu.container.id !== id) {
      submenu.resetState(reset);
    }
  });
}

function containsCssClass(classList) {
  return (
    classList.contains('c-header') ||
    classList.contains('is-active') ||
    classList.contains('js-search-toggle') ||
    classList.contains('is-menu')
  );
}

function instantiateMobileMenu(hasEventListener) {
  if (mediaQuery.matches === false && mobile === null) {
    mobile = new navSubmenu({
      container: navigation,
      expandedDesktop: true,
      expandedMobile: false,
      mediaQuery,
      trigger: document.querySelector('.js-nav-toggle'),
    });
    mobile.init();
    if (hasEventListener === true) {
      mediaQuery.removeEventListener('change', instantiateMobileMenu.bind(this, true));
    }
    searchbar.addEventListener('click', () => mobile.openSearchbar());
  }
}

function instantiateSubmenus() {
  const submenuNodes = [...navigation.getElementsByClassName('js-nav__submenu')];
  if (submenuNodes.length > 0) {
    submenuNodes.forEach((node) => {
      const submenu = new navSubmenu({
        container: node.querySelector('.js-nav__submenu-inner'),
        expandedDesktop: false,
        expandedMobile: false,
        mediaQuery,
        trigger: node.querySelector('.js-nav__trigger'),
      });
      submenu.init();
      submenu.trigger.addEventListener('toggle', submenuHandler);

      const firstLink = submenu.container.querySelector('a');
      submenu.container.addEventListener('focusout', handleFocus);
      if (firstLink) firstLink.addEventListener('focus', handleFocus);

      submenus.push(submenu);
    });
  }
}

function submenuHandler(event) {
  activeNav = event.detail.expanded;
  closeMenus(false, event.detail.container.id);
}

function handleFocus(event) {
  if (
    !this.contains(event.relatedTarget) &&
    document.activeElement !== this &&
    mediaQuery.matches === true
  ) {
    closeMenus(true);
  }
}

function init() {
  if (!navigation) {
    return;
  }

  instantiateSubmenus();

  mediaQuery.addEventListener('change', () => {
    document.body.classList.remove('is-menu');
    navigation.classList.remove('is-active');
    closeMenus(true);
  });

  if (mediaQuery.matches === true) {
    mediaQuery.addEventListener('change', instantiateMobileMenu.bind(this, true));
  } else {
    instantiateMobileMenu();
  }

  document.addEventListener('click', catchClicks, false);
}

export default init;
